import type {
  U3129FindProjectItem,
  U3129HonorariumItem,
  U3129HonorariumProjectRef,
  U3129HonorariumTaskRef,
  U3129TaskItem,
} from '../U3129Service';

function projectRecord(row: U3129HonorariumItem): U3129FindProjectItem | U3129HonorariumProjectRef | undefined {
  return (row as unknown as Record<string, unknown>).project as
    | U3129FindProjectItem
    | U3129HonorariumProjectRef
    | undefined;
}

function taskNatureDescriptions(source: U3129HonorariumTaskRef | U3129TaskItem | undefined): {
  fr: string;
  en: string;
} {
  if (!source) {
    return { fr: '', en: '' };
  }
  return {
    fr: source.workNatureDescriptionFr?.trim() ?? '',
    en: source.workNatureDescriptionEn?.trim() ?? '',
  };
}

/** Libellé natures du projet — codes MyEvent (lecture seule API / findProject). */
export function u3129ProjectWorkNatureFromRow(row: U3129HonorariumItem | null | undefined): string {
  if (!row) {
    return '';
  }
  const project = projectRecord(row);
  const raw = project && 'workNatureDisplay' in project ? project.workNatureDisplay : undefined;
  return raw?.trim() ?? '';
}

/** Descriptions natures tâche selon langue UI (ex. « Cadastre · Implantation ») — BL-0677. */
export function u3129TaskWorkNatureDescriptionForLanguage(
  row: U3129HonorariumItem | null | undefined,
  language: string,
): string {
  const { fr, en } = taskNatureDescriptions(row?.task);
  const lang = (language ?? '').toLowerCase();
  if (lang.startsWith('en')) {
    return en || fr;
  }
  return fr || en;
}

/** Même libellé à partir d’un item findTasks*. */
export function u3129TaskItemWorkNatureDescriptionForLanguage(task: U3129TaskItem | undefined, language: string): string {
  const { fr, en } = taskNatureDescriptions(task);
  const lang = (language ?? '').toLowerCase();
  if (lang.startsWith('en')) {
    return en || fr;
  }
  return fr || en;
}

/** Champs nature tâche à fusionner sur `row.task` depuis findTasks / GET. */
export function u3129HonorariumTaskWorkNatureFieldsFromTaskItem(task: U3129TaskItem): Partial<U3129HonorariumTaskRef> {
  const out: Partial<U3129HonorariumTaskRef> = {};
  const display = task.workNatureDisplay?.trim();
  if (display) {
    out.workNatureDisplay = display;
  }
  const fr = task.workNatureDescriptionFr?.trim();
  if (fr) {
    out.workNatureDescriptionFr = fr;
  }
  const en = task.workNatureDescriptionEn?.trim();
  if (en) {
    out.workNatureDescriptionEn = en;
  }
  return out;
}
